<template style="">
  <div class="Rotation_chart_management">
    
    <div style="margin-left:20px;margin-top:20px;">
      <el-input style="width: 300px;" v-model="RotaChartModule" placeholder="请输入轮播图标题"></el-input>
      <el-button type="primary" style="margin-left:20px;" @click="ser()">查询</el-button>
      <el-button type="primary" style="margin-left:20px;" @click="resetfun()">重置</el-button>
      <el-button type="primary" style="margin-left:20px;margin-top:20px;" @click="go()">发布</el-button>
    </div>
    <el-table :data="tableData" style="width: 98%;margin-left:1%;margin-top:20px;">
      <el-table-column prop="materialName" label="标题" width="180"></el-table-column>
      <el-table-column prop="createdDate" label="发布时间"></el-table-column>
      <el-table-column prop="scheduledRelease" label="定时时间"></el-table-column>
      <el-table-column prop="creator" label="创建人"></el-table-column>
      <el-table-column prop="rotatLanguage" label="中英文">
        <template slot-scope="scope">
          <span>{{scope.row.rotatLanguage==1?'中':'英'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="rotatChartType" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.rotatChartType == 1">普测</span>
          <span v-if="scope.row.rotatChartType == 2">咨询</span>
          <span v-if="scope.row.rotatChartType == 3">访谈</span>
          <span v-if="scope.row.rotatChartType == 4">咨询师列表</span>
          <span v-if="scope.row.rotatChartType == 5">活动</span>
          <span v-if="scope.row.rotatChartType == 6">教育</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发布状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '0'">待审核</span>
          <span v-if="scope.row.status == '5'">草稿</span>
          <span v-if="scope.row.status == '6'">正在审核</span>
          <span v-if="scope.row.status == '4'">需修订</span>
          <span v-if="scope.row.status == '3'">已驳回</span>
          <span v-if="scope.row.status == '2'">已通过</span>
          <span v-if="scope.row.status == '1'">已发布</span>
        </template>
      </el-table-column> 

      <el-table-column prop="isActive" label="是否启用">
        <template slot-scope="scope">
          <span>{{scope.row.isActive == 1?'是':'否'}}</span>
        </template>
      </el-table-column>

      

      <el-table-column label="操作">
        <template slot-scope="scope">
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" v-if="scope.row.status !=2&&scope.row.status !=1" @click="xg(scope.row,1)">{{ scope.row.status == 3 ? '重新编辑' : '修改' }}</span>
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);"  @click="xg(scope.row,2)">查看</span>
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);"  @click="delfun(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:20px;">
      <el-pagination @current-change="handleCurrentChange" :current-page="PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>

    <el-drawer title="我是标题" size="40%" :visible.sync="drawer" :with-header="false">
      <div style="width: 97%;height: 100%;padding-bottom:40px;margin-left:1.5%;padding-top:20px">
        <el-form label-width="80px" :rules="rules" :model="ruleForm" ref="ruleForm" style="padding-top: 20px;">
          <el-form-item label="标题" prop="MaterialName">
            <el-input style="width: 300px;" v-model="ruleForm.MaterialName" placeholder="请输入轮播图标题"></el-input>
          </el-form-item>


          <el-form-item label="上传图片" style="height: 180px;" :rules="[{ required: true, message: '请选择上传图片', trigger: 'change' }]">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择文件</span>
              </i>
            </el-upload>
            <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg 建议比例：2.5:1</p>
          </el-form-item>
           
          <!-- 1为普测2为咨询3为访谈4为咨询师列表5活动6教育 -->
          <el-form-item label="内部跳转">
            <el-select v-model="ruleForm.Type" placeholder="请选择类型">
              <el-option label="普测" value ="1"></el-option>
              <el-option label="咨询" value ="2"></el-option>
              <el-option label="访谈" value ="3"></el-option>
              <el-option label="咨询师列表"  value ="4"></el-option>
              <el-option label="活动" value ="5"></el-option>
              <el-option label="教育" value ="6"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发布对象">
            <el-radio-group v-model="ruleForm.SourceFlg">
              <el-radio label="1">科普宣传轮播图</el-radio>
              <el-radio label="2">app首页轮播图</el-radio>
              <el-radio label="3">心身</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="外部链接">
            <el-input style="width: 300px;" v-model="ruleForm.JumpContentLink" placeholder="请输入外部链接"></el-input>
          </el-form-item>

          <el-form-item label="语言">
            <el-radio-group v-model="ruleForm.ChineseAndEnglish">
              <el-radio label="1">中</el-radio>
              <el-radio label="2">英</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否启用">
            <el-switch v-model="ruleForm.IsActive" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="定时发送">
        <el-radio-group v-model="ruleForm.timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="ruleForm.timisngs == '2'" label="定时时间">
        <el-date-picker  v-model="ruleForm.ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange" >
          </el-date-picker>
      </el-form-item>
      <el-form-item v-if="status=='3'" label="驳回原因">
        <el-input type="textarea" v-model="reasonRejection" :autosize="{ minRows: 2}"></el-input>
      </el-form-item>

          <el-form-item>
            <el-button type="primary" v-if="this.undisble"  @click="submitForm('ruleForm')">{{ ne }}</el-button>
          </el-form-item>

        </el-form>
      </div>
    </el-drawer>
    <el-dialog title="图片裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span> 
    </el-dialog>
  </div>
</template>
<script> 
import PictureCropper from '@/components/pictureCropper.vue'

export default {
  components: {PictureCropper},
  data() {
    return {
      // 裁剪
      Croppdialog:false,
      drawer: false, 
      tableData: [],
      value7: [],
      RotaChartModule: '',
      PageIndex: 1,
      PageSize: 10,
      Counts: 1,
      rowdata:[],
      materialKey:'',
      iscontinuous:false,
      ne:"立即创建",
      imageUrl: "",
      ruleForm: {
        MaterialName: "",//图片标题
        Type:'',
        ChineseAndEnglish:'1',
        IsActive:true,
        SourceFlg:'1',
        JumpContentLink:'',
        timisngs:'',
        ScheduledRelease:''
      },
      pictureFile: "",//图片文件
      MaterialKey: "",//(修改传)
      value7: [],
      djtype: '',
      rules: {
        MaterialName: [
          { required: true, message: '请输入轮播图标题', trigger: 'blur' },
        ]
      },
      undisble:true,
      reasonRejection:'',
      status:'',//发布状态  1、已发布； 2、已通过； 3、已驳回； 4、需修订； 5、草稿； 6、正在审核 
    }
  },
  // ==== 新增计算属性 ====
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 45 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value7 = res.Data;
      }
    })
    this.loading();
  },
  methods: {
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ruleForm.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ruleForm.ScheduledRelease || this.ruleForm.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      } 
      
      try {
        const selectedDate = new Date(this.ruleForm.ScheduledRelease); 
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
     // 确认裁剪并关闭弹窗
     async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.ruleForm.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ruleForm.ScheduledRelease = adjustedDate;
        }
      }
    },
    submitForm(formName) {//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 单独检查图片
          if (!this.pictureFile && !this.imageUrl) {
            this.$message.error('请选择上传图片');
            return false;
          }
          this.iscontinuous = true;
          var from = new FormData();
          this.ruleForm.ScheduledRelease=this.ruleForm.timisngs==1 || this.ruleForm.timisngs==''?'':this.ruleForm.ScheduledRelease;
          from.append('MaterialName', this.ruleForm.MaterialName);
          from.append('IsActive', this.ruleForm.IsActive);
          from.append('ChineseAndEnglish', this.ruleForm.ChineseAndEnglish);
          from.append('Type', this.ruleForm.Type);
          from.append('JumpContentLink', this.ruleForm.JumpContentLink);
          from.append('SourceFlg', this.ruleForm.SourceFlg);
          from.append('ScheduledRelease', this.ruleForm.ScheduledRelease);
          if (this.djtype == 2) {
            from.append('MaterialKey', this.materialKey);
            from.append('Operate', 2);
            from.append('pictureFile',this.pictureFile.raw?this.pictureFile.raw:this.imageUrl);
          } else {
            from.append('Operate', 1);
            from.append('pictureFile',this.pictureFile.raw?this.pictureFile.raw:this.imageUrl);
          }
          this.$Http_Post('/management/homeChart', from, {'Content-Type': 'multipart/form-data'}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.drawer = false;
              this.iscontinuous = false;
              this.Global.request_successful(res.Message);
              this.loading();
            } else {
              this.iscontinuous = false;
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.pictureFile = file;
        this.Croppdialog = true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },

    resetfun(){
      this.RotaChartModule = '';
      this.PageIndex = 1;
      this.loading();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.loading();
    },

    loading() {
      this.$Http_Post('management/homeChartList', { MaterialName: this.RotaChartModule, PageIndex: this.PageIndex, PageSize: this.PageSize, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts;
          this.tableData = res.Data; 
        }
      })
    },
    delfun(rom) {
      this.$Http_Post('management/materialDel', { MaterialKey: rom.materialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      this.PageIndex = 1;
      this.loading();

    },
    go() {
      this.ne = "立即创建"
      this.undisble=true;
      this.drawer = true
      this.djtype = 1
      this.materialKey = ''
      this.ruleForm = {
        MaterialName:'',//图片标题
        Type:'',
        ChineseAndEnglish:'1',
        IsActive:'1',
        SourceFlg:'1',
        JumpContentLink:'',
        timisngs:'',
        ScheduledRelease:''
      }
      this.imageUrl = ''
      // this.$router.push({path:"/propagate/Carousel_map_release",query:{type:1}})
    },
    ser() {
      this.PageIndex = 1;
      this.loading();
    },
    xg(rom,type) {
      this.djtype = 2;
      this.materialKey = rom.materialKey;
      this.rowdata = rom;
      this.ruleForm = {
        MaterialName:rom.materialName,//图片标题
        Type:rom.rotatChartType,
        ChineseAndEnglish:rom.rotatLanguage,
        IsActive:rom.isActive,
        SourceFlg:rom.sourceFlg,
        JumpContentLink:rom.jumpContentLink,
        timisngs:rom.scheduledRelease?'2':'1',
        ScheduledRelease:rom.scheduledRelease
      };
      this.imageUrl = rom.materialPath;
      this.ne = "立即修改";
      this.drawer = true;
      this.undisble =this.rowdata.status!='1'&&this.rowdata.status!='2';
      this.undisble = type==2 ? false : this.undisble;
      this.reasonRejection=type==1 ? '' : (this.rowdata.status==3 ? this.rowdata.reasonRejection : '');    
      this.status=type==1 ? '' : this.rowdata.status; 
      // this.$router.push({path:"/propagate/Carousel_map_release",query:{type:2,MaterialKey:rom.MaterialKey}})
    }
  },
}
</script>
<style>
.cropper-content-box{height:500px !important;width:600px !important;}
  .Rotation_chart_management{width: 100%;height: 100%;background-color: #fff;}
  .Rotation_chart_management .el-table--enable-row-transition .el-table__body td{text-align:center;}
  .Rotation_chart_management .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .Rotation_chart_management .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .Rotation_chart_management .avatar {width: 215px;height: 148px;display: block;}
  .Rotation_chart_management .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .Rotation_chart_management .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .Rotation_chart_management .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .Rotation_chart_management .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .Rotation_chart_management .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
</style>
